// Action Types
export const FETCH_VALUE_SELLING_CARD_REQUEST = "FETCH_VALUE_SELLING_CARD_REQUEST";
export const FETCH_VALUE_SELLING_CARD_SUCCESS = "FETCH_VALUE_SELLING_CARD_SUCCESS";
export const FETCH_VALUE_SELLING_CARD_FAILURE = "FETCH_VALUE_SELLING_CARD_FAILURE";

// Action Creators
export const fetchValueSellingCardRequest = ({opportunityId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_VALUE_SELLING_CARD_REQUEST,
      payload: {opportunityId},
    });
  };
};
export const fetchValueSellingCardSuccess = (data) => ({
  type: FETCH_VALUE_SELLING_CARD_SUCCESS,
  payload: data,
});
export const fetchValueSellingCardFailure = (error) => ({
  type: FETCH_VALUE_SELLING_CARD_FAILURE,
  payload: error,
});
